<template>
  <svg width="22" height="22" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" :fill="theme === 'white' ? 'white' : '#3E4095'"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1634 21.6988C10.9687 22.3927 10 21.8472 10 20.4775V10.5247C10 9.15419 10.9654 8.60616 12.1634 9.30171L21.4032 14.6667C22.196 15.1274 22.2019 15.8699 21.4032 16.3339L12.1634 21.6988Z" :fill="theme === 'white' ? '#3E4095' : 'white'"/>
  </svg>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
    },
  },
}
</script>

<style>

</style>
